import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal } from 'antd';
import FormImports from './FormImports';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import constants from '../../config/api/constants';

const ModalImportItem = ({
  title = 'importListItems',
  downloadRoute = constants.customListImportTemplate,
  downloadText = 'downloadBaseTemplate',
  modalWidth = '70%',
  show,
  handleClose,
  importList,
  showSaveButton,
  onUploadItems,
  renderItems,
}) => {
  const [successImport, setSuccessImport] = useState(false);
  const { translate: t } = useDictionaryTranslation();

  const { idAcount } = useSelector((state) => {
    return {
      idAcount: state.auth.accountData._id,
    };
  });

  const uploadImportList = useCallback(
    async (file) => {
      try {
        importList({ file, idAcount });
        setSuccessImport(true);
      } catch (error) {
        console.error(error);
      }
    },
    [importList, idAcount],
  );

  const handleClosseModal = () => {
    handleClose({ successImport });
    setSuccessImport(false);
  };

  const onUpload = () => {
    onUploadItems();
  };

  return (
    <>
      <Modal
        maskClosable={false}
        title={t(title)}
        centered
        width={modalWidth}
        height="80%"
        onCancel={handleClosseModal}
        destroyOnClose
        open={show}
        footer={
          showSaveButton ? (
            <Button type="primary" onClick={onUpload}>
              {t('send')}
            </Button>
          ) : null
        }
      >
        <FormImports downloadRoute={downloadRoute} downloadText={downloadText} uploadImportList={uploadImportList} />

        {renderItems?.()}
      </Modal>
    </>
  );
};

ModalImportItem.propTypes = {
  title: PropTypes.string,
  downloadRoute: PropTypes.string,
  downloadText: PropTypes.string,
  modalWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  importList: PropTypes.func,
  showSaveButton: PropTypes.bool,
  onUploadItems: PropTypes.func,
  renderItems: PropTypes.func,
};

export default ModalImportItem;
